<template>
    <z-basePage :title="'文件浏览'">
        <div class="search-top">
            <span>文件类型</span>
            <el-select class="top-choose" v-model="search.type" clearable>
                <el-option v-for="item in taskTpl" :key="item.id" :value="item.id" :label="item.tpl_name" >
                </el-option>
            </el-select>
            <span>名称/编号</span>
            <el-input class="top-choose" v-model="search.text" placeholder="输入名称或编号"></el-input>
            
            <div class="back-btn blue shift" @click="searchDoc(1)">搜索</div>
        </div>
        
        <div class="back-list">
            <div class="list-head">
                <div>文件编号</div>
                <div>文件类型</div>
                <div>发布时间</div>
                <div>创建者</div>
                <div>文件名称</div>
                <div>操作</div>
            </div>
            <z-scrollDiv class="main">
                <div class="list-item"  v-for="item in dataList" :key="item.id">
                    <div>{{ item.code }}</div>
                    <div class="overhide" :title="item.tpl_name">{{ item.tpl_name }}</div>
                    <div>{{ item.created_at }}</div>
                    <div class="overhide" :title="item.real_name">{{ item.real_name }}</div>
                    <div class="overhide" :title="item.doc_name">{{ item.doc_name }}</div>
                    <div>
                        <a @click="downloadFile(item.id)"></a>
                    </div>
                </div>
                <z-noData :list="dataList"></z-noData>
            </z-scrollDiv>
        </div>

        <el-pagination
            @current-change="searchDoc"
            :current-page.sync="data.current_page"
            :total="data.total"
            :page-size="data.per_page"
            layout="prev, pager, next, jumper"
        ></el-pagination>

    </z-basePage>
</template>

<script>
    import { mapState } from "vuex"

    export default {
        data(){
            return {
                search:{
                    type:"",
                    text:"",
                },
                data:{},
            }
        },
        computed:{
            ...mapState(["taskTpl"]),
            dataList(){
                return this.data.list;
            },
        },
        created(){
            this.$func.getTaskTpl();
            this.getData();
        },  
        methods:{
            getData(obj){  //获取数据
                let url = `api/admin/document/list`;
                let config = {params:obj};
                this.$http.get(url,config).then(res=>{
                    if(res.status == 200){
                        this.data =  res.res_data;
                    }
                });
            },
            searchDoc(page){  //搜索
                page = page == undefined?this.data.current_page:page;
                let obj = {
                    page:page,
                    template_id:this.search.type,
                    keyword:this.search.text,
                }
                this.getData(obj);
            },
            downloadFile(id){  //下载文件
                this.$http.get(`api/clerk/task_doc/${id}/download`);
            },
        }
    }
</script>

<style lang="less" scoped>
	@import "~src/assets/less/backless/var.less";

    .back-list{
        margin-top:10px;
        height:calc(~"100% - @{line} - @{search_m} - 10px - @{page_need}");
        // 列表高度
        .main{
            height:calc(~"100% - @{list-head}");
        }
    }
    .list-head,.list-item{
        >div:nth-of-type(1){
            width: 15%;
        }
        >div:nth-of-type(2){
            width: 15%;
        }
        >div:nth-of-type(3){
            width: 20%;
        }
        >div:nth-of-type(4){
            width: 12%;
            padding-right: 3%;
        }
        >div:nth-of-type(5){
            width: 20%;
        }
        >div:last-of-type{
            width: 10%;
            padding-left: 5%;
            height: 100%;
            a{
                display: block;
                height: 20px;
                width:20px;
                position: relative;
                top: 50%;
                transform: translateY(-50%);
                cursor: pointer;
                background:url("../../../assets/image/back-download.png") no-repeat;
                &:hover{
                    background-position-y:-20px; 
                }
                &:active{
                    background-position-y:-40px; 
                }
            }
        }
    }
</style>





// WEBPACK FOOTER //
// page-skim.vue?5db4add0